import { Link } from "react-router-dom";
import React from 'react';

export default function HealthcareSmart({ data, extraClass = "" }) {
    return (
        <>

            <div className={`smart-solutions ${extraClass}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-10 col-lg-5">
                            <div className="solutions-content">
                                <h3 className="heading" dangerouslySetInnerHTML={{ __html: data.heading }} />
                                <p>{data.description}</p>
                                {data.buttonText && (
                                    <div className="smart-btn">
                                        <Link to={data.buttonLink} className="default-btn">
                                            <span>{data.buttonText}</span>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-6 ">
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



